var map = {
	"./NFO-black.png": 83265,
	"./NFO-black.svg": 29214,
	"./NFO.png": 84767,
	"./all-black.png": 57599,
	"./all-black.svg": 71376,
	"./all.png": 2015,
	"./insta-redeem-black.png": 29913,
	"./insta-redeem-black.svg": 74915,
	"./insta-redeem.png": 64071,
	"./recommended-black.png": 52183,
	"./recommended-black.svg": 76905,
	"./recommended.png": 18776,
	"./tax-saver-black.png": 64326,
	"./tax-saver-black.svg": 53197,
	"./tax-saver.png": 23797,
	"./wishlist-black.png": 37000,
	"./wishlist.png": 26978
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35006;